import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

const LoadMore = ({ isFetchingNextPage }: { isFetchingNextPage: boolean }) => {
  const { t } = useTranslation('Vindoc');

  if (!isFetchingNextPage) return null;

  return (
    <Select.Option disabled>
      <span className="flex items-center justify-center">{t('Loading more...')}</span>
    </Select.Option>
  );
};

export default LoadMore;
